// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dg_bIcNDzGYBXdTVenjw {
  background-color: #EFEFEF;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
}
.J3H9RT5WFXYsoRnTaAPt {
  height: 68px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding-left: 30px;
}
.In1a1BlE4En27hOAo1en {
  display: flex;
  padding: 10px;
  flex: 1;
}
.ZjosUTbf7B4Z_J3IGB68 {
  flex: 1;
  background-color: #fff;
  height: 100%;
  padding: 26px;
  background-color: #ccc;
}
.RFLlzTDrre4_UxaiSEUQ {
  width: 380px;
  background-color: #fff;
  margin-left: 10px;
  height: 100%;
}
.VBsZ2XEBvabrDVVwwLT2 {
  font-size: 24px;
}
.VHRWo9CaxlspXFip552N {
  background-color: #fff;
  padding: 10px;
  width: 100%;
  height: 100%;
}
.KqR_EhyUXCKefkCbxzMC {
  position: absolute;
  left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/MaterialBalance/index.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AACF;AAEA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAGA;EACE,aAAA;EACA,aAAA;EACA,OAAA;AADF;AAIA;EACE,OAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAFF;AAKA;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAHF;AAMA;EACE,eAAA;AAJF;AAOA;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AALF;AAQA;EACE,kBAAA;EACA,UAAA;AANF","sourcesContent":[".pageContainer {\n  background-color: #EFEFEF;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n}\n\n.header {\n  height: 68px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  padding-left: 30px;\n}\n\n.body {\n  display: flex;\n  padding: 10px;\n  flex: 1;\n}\n\n.left {\n  flex: 1;\n  background-color: #fff;\n  height: 100%;\n  padding: 26px;\n  background-color: #ccc;\n}\n\n.right {\n  width: 380px;\n  background-color: #fff;\n  margin-left: 10px;\n  height: 100%;\n}\n\n.iconAction {\n  font-size: 24px;\n}\n\n.tableContainer {\n  background-color: #fff;\n  padding: 10px;\n  width: 100%;\n  height: 100%;\n}\n\n.backBtn {\n  position: absolute;\n  left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `dg_bIcNDzGYBXdTVenjw`,
	"header": `J3H9RT5WFXYsoRnTaAPt`,
	"body": `In1a1BlE4En27hOAo1en`,
	"left": `ZjosUTbf7B4Z_J3IGB68`,
	"right": `RFLlzTDrre4_UxaiSEUQ`,
	"iconAction": `VBsZ2XEBvabrDVVwwLT2`,
	"tableContainer": `VHRWo9CaxlspXFip552N`,
	"backBtn": `KqR_EhyUXCKefkCbxzMC`
};
export default ___CSS_LOADER_EXPORT___;
